import { useContext } from 'react';
import MessageContext from './Context';

export const useMessage = () => {
  return useContext(MessageContext);
};
